<template>
  <div>
    <slot name="activator" :on="on"></slot>

    <portal to="modals">
      <transition name="navi-modal">
        <div class="navi-modal" :class="setClassModifiers('navi-modal--')" v-if="show">
          <div class="navi-modal__bg" @click="handleClickBg ? show = false : null" v-if="!noBackground"></div>
          <div class="navi-modal__inner d-flex direction-column" :style="{
            minWidth: computedWidth,
            margin: margin + 'px'
          }">
            <div class="navi-modal__close" @click="show = false" v-if="!unclosable"><span class="icon-close"></span></div>
            <div class="navi-modal__header" :class="unclosable ? 'navi-modal__header--unclosable' : ''">
              <div v-show="showSettingsMobile && !screen.breakPoint.tabLand" @click="$emit('update:showSettingsMobile', false)" :key="0" class="text--uppercase">
                <i class="icon-show rotate-90 mr-05 d-inline-block"></i><slot name="header"></slot>
              </div>

              <div v-show="screen.breakPoint.tabLand ? true : !showSettingsMobile" @click="showSettingsMobile = false" :key="1" class="text--uppercase">
                {{title}}
              </div>

              <div class="navi-modal__header-controls" v-if="$slots.headerControls">
                <slot name="headerControls"></slot>
              </div>
            </div>

            <div class="navi-modal__modal">
              <div class="navi-modal__modal-menu" :style="{ maxHeight: menuHeight + 'px', height: full ? menuHeight + 'px' : '' }">
                <div class="navi-modal__modal-menu-inner py-2">
                  <slot name="navigation"></slot>
                </div>
              </div>

              <transition name="slide-left">
                <div class="navi-modal__modal-content" v-if="screen.breakPoint.tabLand || showSettingsMobile">
                  <div
                    class="navi-modal__main"
                    @scroll="(e) => $emit('scroll', e)"
                    :style="{ maxHeight: containerHeight + 'px', height: full ? containerHeight + 'px' : '' }"
                    v-scrollable
                  >
                    <slot></slot>
                  </div>

                  <div v-if="$slots.footer" class="navi-modal__footer">
                    <div class="navi-modal__footer-inner">
                      <slot name="footer"></slot>
                    </div>
                  </div>
                </div>
              </transition>
            </div>

            <div v-if="$slots.globalFooter" class="navi-modal__global-footer">
              <div class="navi-modal__global-footer-inner">
                <slot name="globalFooter"></slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </portal>
  </div>
</template>

<script>
// import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'

import setClassModifiers from '@/mixins/setClassModifiers'
import modalActivate from '@/mixins/modalActivate'
import screen from '@/mixins/screen'

import scrollable from '@/directives/scrollable'

export default {
  directives: {
    scrollable
  },

  mixins: [setClassModifiers, modalActivate, screen],

  props: {
    title: {
      type: String,
      default: null
    },

    showSettingsMobile: {
      type: Boolean,
      default: false
    },
    /**
     * Removes background layer if true
     */
    noBackground: {
      type: Boolean,
      default: false
    },

    handleClickBg: {
      type: Boolean,
      default: false
    },

    /**
     * @values slide-down, slide-up
     */
    animation: {
      type: String,
      default: 'modal'
    },
    noPadding: {
      type: Boolean,
      default: false
    },
    minWidth: {
      type: String,
      default: '45rem'
    },
    /**
     * Removes close button
     */
    unclosable: {
      type: Boolean,
      default: false
    },

    full: {
      type: Boolean,
      default: false
    },

    blockScroll: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      modalHeaderHeight: 0,
      modalFooterHeight: 0,
      modalGlobalFooterHeight: 0,
      interval: undefined,
      count: 0
    }
  },

  computed: {
    computedWidth () {
      if (this.full) {
        return '100%'
      }

      return this.minWidth
    },

    margin () {
      if (this.full) {
        return 0
      }

      return 30
    },

    containerHeight () {
      return this.screen.height - this.modalHeaderHeight - this.modalFooterHeight - this.modalGlobalFooterHeight - (this.margin * 2)
    },

    menuHeight () {
      return this.screen.height - this.modalHeaderHeight - this.modalGlobalFooterHeight - (this.margin * 2)
    }
  },

  methods: {
    computeHeights () {
      const modalHeader = document.querySelector('.navi-modal__header')
      const modalFooter = document.querySelector('.navi-modal__footer')
      const modalGlobalFooter = document.querySelector('.navi-modal__global-footer')

      this.$nextTick(() => {
        modalHeader ? this.modalHeaderHeight = modalHeader.clientHeight : this.modalHeaderHeight = 0
        modalFooter ? this.modalFooterHeight = modalFooter.clientHeight : this.modalFooterHeight = 0
        modalGlobalFooter ? this.modalGlobalFooterHeight = modalGlobalFooter.clientHeight : this.modalGlobalFooterHeight = 0
      })
    },

    initSizes () {
      const setInitialHeights = () => {
        this.computeHeights()

        this.count = this.count + 200
        if (this.count >= 1400) {
          clearInterval(this.interval)
        }
      }

      this.interval = setInterval(setInitialHeights, 100)
    }
  },

  async mounted () {
    if (this.show) {
      this.initSizes()
    }
  },

  watch: {
    show (newVal) {
      if (newVal === true) {
        this.initSizes()
      }

      this.$emit('input', newVal)

      if (newVal === true) {
        this.$emit('input', newVal)

        /** istanbul ignore next */
        if (this.closeAfter) {
          setTimeout(() => {
            this.close()
          }, this.closeAfter)
        }
      }

      if (newVal === true && this.blockScroll === true) {
        this.$locker.lock('body', {
          reserveScrollBarGap: true
        })
      } else {
        /** istanbul ignore next */
        setTimeout(() => {
          this.$locker.unlockAll()
        }, 100)
      }
    },

    value (newVal) {
      this.show = newVal
    },

    'screen.height' () {
      this.computeHeights()
    },

    showSettingsMobile () {
      setTimeout(() => {
        this.computeHeights()
      }, 50)
    }
  }
}
</script>

<style lang="scss">
  .navi-modal {
    position: fixed;
    top: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    z-index: 99999;

    @include computedVh(100);

    &__bg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 9999;
      background-color: rgba($color-black, .75);
    }

    &__inner {
      background-color: $color-white;
      position: relative;
      z-index: 99999;
      border-radius: $border-radius;
      overflow: hidden;
    }

    &--full &__inner {
      border-radius: 0;
    }

    &__container {
      overflow-y: auto;
    }

    &__modal {
      position: relative;

      @include respond(tab-land) {
        display: flex;
        justify-content: stretch;
      }
    }

    &__modal-menu {
      @include respond(tab-land) {
        border-right: 1px #EAEAEA solid;
        width: 25%;
      }

      overflow-y: auto;
    }

    &__main {
      overflow: auto;
    }

    &__close {
      position: absolute;
      font-size: 2.2rem;
      color: $color-grey;
      top: 1.3rem;
      right: 1.5rem;
      cursor: pointer;
      z-index: 999999;

      @include iosTop(1.3rem)
    }

    &__modal-content {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      background-color: $color-white;
      overflow: hidden;

      @include respond(tab-land) {
        width: 75%;

        height: initial;
        position: initial;
        top: initial;
        left: initial;
        z-index: initial;
      }
    }

    &__header,
    &__main,
    &__footer-inner,
    &__global-footer-inner
    {
      padding: 2rem 2rem;
    }

    &--no-padding &__main {
      padding: 0;
    }

    &__header {
      background-color: $color-white;
      font-weight: 500;
      border-bottom: 1px $color-space-lighten solid;

      @include iosPaddingTop(2rem);

      display: flex;
      align-items: center;

      &-controls {
        margin-left: auto;
      }
    }

    &__footer, &__global-footer {
      background-color: $color-white;
      border-top: 1px #EAEAEA solid;
      z-index: 1;
    }
  }
</style>
